import { Box, Typography, Modal } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import BaseButton from "../../BaseButton";

export default function KitCodeHelperModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '100%', sm: '500px', md: '600px' },
          maxWidth: '90vw',
          maxHeight: '90vh',
          borderRadius: '16px',
          background: 'white',
          padding: { xs: '24px 16px', sm: '32px' },
          overflowY: 'auto',
          outline: 'none'
        }}
      >
        {/* Close button */}
        <Box
          sx={{
            position: 'absolute',
            right: '16px',
            top: '16px',
            cursor: 'pointer',
            zIndex: 10
          }}
          onClick={onClose}
        >
          <CloseIcon sx={{ width: 28, height: 28, color: '#46545F' }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h2"
          sx={{
            color: '#5A3BC7',
            fontSize: { xs: '20px', sm: '24px' },
            fontWeight: 600,
            mb: 2,
            pr: 4
          }}
        >
          How to Locate the Kit Code
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            color: '#46545F',
            fontSize: '14px',
            mb: 3,
            lineHeight: 1.6
          }}
        >
          The Kit Code (registration number) is a unique identifier printed on the DNA test kit.
          You can find it in the following location:
        </Typography>

        {/* Image with red circle highlight */}
        <Box
          sx={{
            mb: 3,
            borderRadius: '12px',
            overflow: 'hidden',
            border: '1px solid #ECEFF1',
            background: '#F6F9FC',
            p: 2
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: '100%'
            }}
          >
            <Box
              component="img"
              src="/kit-registration-code.svg"
              alt="Kit Code location"
              sx={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
            {/* Red circle overlay to highlight Kit Code location */}
            <Box
              sx={{
                position: 'absolute',
                top: '55%',
                left: '72%',
                transform: 'translate(-50%, -50%)',
                width: '32%',
                height: '18%',
                border: '4px solid #E53935',
                borderRadius: '50%',
                pointerEvents: 'none'
              }}
            />
          </Box>
        </Box>

        {/* Additional instructions */}
        <Box
          sx={{
            p: 2,
            borderRadius: '8px',
            background: '#F6F9FC',
            border: '1px solid #5B87EF',
            mb: 3
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: '#46545F',
              fontSize: '13px',
              lineHeight: 1.6
            }}
          >
            <strong>Tips:</strong>
            <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
              <li>The Kit Code (registration number) is 14 digits long.</li>
              <li>It may be located on the kit box, tube label, or instruction card.</li>
            </ul>
          </Typography>
        </Box>

        {/* Close button */}
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <BaseButton
            type="button"
            onClick={onClose}
            buttonType="primary"
            sx={{ minWidth: '140px' }}
          >
            Got It
          </BaseButton>
        </Box>
      </Box>
    </Modal>
  );
}
